<template>
  <div class="detail-back" @click="goBack" :style="{ left: position ? position.left - 50 + 'px' : null }">
    <img class="icon" src="@/assets/images/back-icon.svg" alt="" />
  </div>
</template>

<script>
export default {
  props: {
    position: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      scrollTop: 0
    };
  },
  mounted() {
    // window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    // window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    // onScroll() {
    //   const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    //   // console.log(scrollTop);
    //   this.scrollTop = scrollTop;
    // },
    // 返回
    goBack() {
      if (history.length > 2) {
        // window.history.back();
        this.$router.go(-1);
      } else {
        this.$router.push(`/${this.alias}/`);
      }
      // 将服务端数据置空，防止动态切换默认渲染此数据
      this.$store.commit("set_ssr_component_data", []);
    }
  }
};
</script>

<style lang="less" scoped>
.detail-back {
  position: fixed;
  left: -100px;
  top: 80px;
  width: 40px;
  height: 40px;
  background: #ffffff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: #000;
  cursor: pointer;
  &:hover {
    background: #f5f5f5;
  }

  .icon {
    width: 18px;
    height: 18px;
  }
}
</style>
